module.exports = __webpack_public_path__ + "b10ecee279e3a8d11d5ec3193b68d8bf.woff2";